import React from 'react'
import { WarningBanner } from '/react4xp/shared/warning-banner/warning-banner'

export default (props) => <WarningBanner {...props} />
